export const ROUTE_PATH = '/guest-parking';
